import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type {
  GetMasterPayrollListOldServicesInterface,
  GetPayrollDetailByUserIdOldServicesInterface,
  PayrollQueryParamsOldInterface,
} from 'features/Enterprise/Payroll/services/payroll/masterPayrollOld'

export interface MasterPayrollOldInitialStateInterface {
  isLoading: boolean
  hubLists: {
    location_id: number
    location_name: string
    location_type: string
  }[]
  selectedHub: MasterPayrollOldInitialStateInterface['hubLists'][0] | undefined
  masterPayrollList: GetMasterPayrollListOldServicesInterface['data']
  payrollDetailByUserId: GetPayrollDetailByUserIdOldServicesInterface['data'] | ObjectNullType
  query: PayrollQueryParamsOldInterface
  queryPayrollDetailByUserId: PayrollQueryParamsOldInterface
}

const initialState: MasterPayrollOldInitialStateInterface = {
  isLoading: false,
  hubLists: [],
  selectedHub: undefined,
  masterPayrollList: [],
  payrollDetailByUserId: {},
  query: {
    direction: 'end_date',
    pageIndex: 1,
    pageSize: 10,
    sort: 'desc',
    numberOfElements: 0,
  },
  queryPayrollDetailByUserId: {
    direction: 'end_date',
    pageIndex: 1,
    pageSize: 10,
    sort: 'desc',
    numberOfElements: 0,
  },
}

export const sliceName = 'masterPayrollOld'

const appSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    reset: () => initialState,
    setLoading: (
      state,
      action: PayloadAction<MasterPayrollOldInitialStateInterface['isLoading']>,
    ) => {
      state.isLoading = action.payload
    },
    setHubList: (
      state,
      action: PayloadAction<MasterPayrollOldInitialStateInterface['hubLists']>,
    ) => {
      state.hubLists = action.payload
    },
    setSelectedHub: (
      state,
      action: PayloadAction<MasterPayrollOldInitialStateInterface['selectedHub']>,
    ) => {
      state.selectedHub = action.payload
    },
    setQuery: (state, action: PayloadAction<MasterPayrollOldInitialStateInterface['query']>) => {
      state.query = action.payload
    },
    setQueryPayrollDetailByUserId: (
      state,
      action: PayloadAction<MasterPayrollOldInitialStateInterface['queryPayrollDetailByUserId']>,
    ) => {
      state.queryPayrollDetailByUserId = action.payload
    },
    setMasterPayrollList: (
      state,
      action: PayloadAction<MasterPayrollOldInitialStateInterface['masterPayrollList']>,
    ) => {
      state.masterPayrollList = action.payload
    },
    setPayrollDetailByUserId: (
      state,
      action: PayloadAction<MasterPayrollOldInitialStateInterface['payrollDetailByUserId']>,
    ) => {
      state.payrollDetailByUserId = action.payload
    },
  },
})

export const {
  setHubList,
  setLoading,
  setSelectedHub,
  setMasterPayrollList,
  setPayrollDetailByUserId,
  setQuery,
  setQueryPayrollDetailByUserId,
  reset,
} = appSlice.actions

export default appSlice.reducer
